import { getWeekDay } from 'util/Date';
import { ServiceOffering, WeekDay } from 'olo-service';
import { DateTime } from 'luxon';

const getHour = (time: string) => Math.floor(parseInt(time)/100);
const getMinutes = (time: string) => parseInt(time) % 100;

export const toDateTime = (time: string, timezone?: string) => DateTime.fromObject({
  hour: getHour(time),
  minute: getMinutes(time)
}, { zone: timezone });

export const getCurrentHours = (timezone: string, service?: ServiceOffering) => {
  if (!service) return;

  const weekday = getWeekDay(timezone);

  if (!weekday) return;

  const hours = service.hours[weekday as WeekDay];

  if (!hours) return;

  return hours.map(({ start, end }) => ({
    startTime: toDateTime(start, timezone),
    endTime: toDateTime(end, timezone),
  })).filter(({ startTime, endTime }) => (
    startTime.diffNow().milliseconds <= 0 &&
    endTime.diffNow().milliseconds >= 0
  ))[0];
};
